<template>
<div>

    <div class="mx-auto text-center">
        <div class="d-inline-flex">
            <div
                class="interaction-choice__row mb-3 mx-2"
                v-for="(subInteraction, i) in subInteractionsWithVariants.slice(0,2)"
                :key="i"
            >
                <sub-interaction-tile 
                    @select="handleSelect(subInteraction)"
                    :subInteraction="subInteraction"
                />
            </div>
        </div>
        <div class="d-inline-flex">
            <div
                class="interaction-choice__row mb-3 mx-2"
                v-for="(subInteraction, i) in subInteractionsWithVariants.slice(2,4)"
                :key="i+'a'"
            >
                <sub-interaction-tile 
                    @select="handleSelect(subInteraction)"
                    :subInteraction="subInteraction"
                />
            </div>
        </div>
        <div class="d-inline-flex">
            <div
                class="interaction-choice__row mb-3 mx-2"
                v-for="(subInteraction, i) in subInteractionsWithVariants.slice(4)"
                :key="i+'b'"
            >
                <sub-interaction-tile 
                    @select="handleSelect(subInteraction)"
                    :subInteraction="subInteraction"
                />
            </div>
        </div>
    </div>
</div>
</template>
<script>
import subInteractionTile from '@/components/ui/subInteractionTile'
import { ASSETS_URL } from '@/constants/misc'
export default {
    name: 'interactionChoice',
    components: {
        'sub-interaction-tile': subInteractionTile
    },
    props: {
        item: {
            type: Object
        },
        subInteractions: {
            type: Array
        }
    },
    computed: {
        subInteractionsWithVariants() {
            const variants = ['bq-burgundy', 'bq-blue', 'bq-turquoise', 'bq-orange', 'bq-red']
            
            return this.subInteractions.map((subInteraction, i) => {
                const iconPath = this.$t(`INTERACTION_BASE_SELECTION_ICON_${subInteraction.disabled ? 'disabled_' : ''}${this.$t(subInteraction.text)}`)
                return {
                    ...subInteraction,
                    icon: `${ASSETS_URL}${iconPath}`,
                    variant: variants[i] 
                }

            })
        }
    },
    methods: {
        handleSelect(subInteraction) {
            this.$emit('select', subInteraction)
        },
    },
}
</script>
<style lang="scss">
.interaction-choice__row {
    @media screen and (max-width: 363px) {
        margin: 0.3em 0.25em !important;
    }
}
</style>